import { VFC } from "react";
import { Button } from "src/components/button";
import { useCopyToClipboard } from "src/hooks/use-copy-to-clipboard.hook";

export interface CopyButtonProps {
  data: string;
}

export const CopyButton: VFC<CopyButtonProps> = ({ data }) => {
  const [state, copyToClipboard] = useCopyToClipboard();
  const copy = () => copyToClipboard(data);

  return (
    <Button block color="primary" onClick={copy}>
      {state.copied ? "Copied!" : "Copy to Clipboard"}
    </Button>
  );
};
